import axios from 'axios';
import { apiUrl } from '../Config';

const getAuthToken = () => {
    return localStorage.getItem('token') || localStorage.getItem('authToken');
};

export const getEmployerInterviews = async (category = 'all') => {
    try {
        const token = getAuthToken();
        const response = await axios.get(`${apiUrl}/interviews/getemployer/categorized`, {
            headers: { Authorization: `Bearer ${token}` },
            params: { category }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching employer interviews:', error);
        throw error;
    }
};

export const cancelInterviewApi = async (id, data = {}) => {
    try {
        const token = getAuthToken();
        const response = await axios.put(`${apiUrl}/interviews/${id}/cancel`, data, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data;
    } catch (error) {
        console.error('Error canceling interview:', error);
        throw error;
    }
};

export const rescheduleInterviewApi = async (id, data) => {
    try {
        const token = getAuthToken();
        const response = await axios.put(`${apiUrl}/interviews/${id}/reschedule`, data, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data;
    } catch (error) {
        console.error('Error rescheduling interview:', error);
        throw error;
    }
};

export const updateInterviewStatusApi = async (id, status, data = {}) => {
    try {
        const token = getAuthToken();
        const response = await axios.put(`${apiUrl}/interviews/${id}/status`, { status, ...data }, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data;
    } catch (error) {
        console.error('Error updating interview status:', error);
        throw error;
    }
};
